const Utils = {
  capitalize(value) {
    return value.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
  },
  lowerCase(value) {
    return value.replace('_', ' ').toLowerCase();
  },
  sentenceCase(value) {
    return value.charAt(0).toUpperCase() + value.replace('_', ' ').slice(1).toLowerCase();
  },
  classStyle(props, defaultClassStyle) {
    let style = props.classStyle ? props.classStyle : defaultClassStyle;
    if (props.errorClassStyle) {
      style += ` ${props.errorClassStyle}`;
    }
    return style;
  },
  errorClassForIndex(errors, index, field) {
    if (errors[index] && errors[index][field]) {
      return 'error';
    }
    return '';
  },
  displayForProfiles(profiles, profile) {
    return profiles.indexOf(profile) > -1;
  },
  hideForProfiles(profiles, profile) {
    return !this.displayForProfiles(profiles, profile);
  },
  gup(name) {
    // grab url param
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const results = new RegExp(`[\\?&]${name}=([^&#]*)`).exec(location.href);
    return results == null ? null : results[1];
  },
  isBlank(val) {
    return val === 'NULL' || val === '' || val == null;
  },
  isNewPage(page) {
    return location.href.includes(`${page}/new`);
  },
  parseInt(value, defaultValue) {
    return this.isBlank(value) ? defaultValue : parseInt(value);
  },
  timeFormat() {
    const locale = navigator.language || navigator.userLanguage;
    return locale.substr(0, 2) === 'en' ? 'h:mm a' : 'H:mm';
  },
  momentDateFormat() {
    return GLOBAL_VAR.current_shop.settings.date_format.toLowerCase().toUpperCase();
  },
  momentDateTimeFormat() {
    return `${this.momentDateFormat()} ${this.timeFormat()}`;
  },
  dateFormat() {
    return GLOBAL_VAR.current_shop.settings.date_format.toLowerCase().replace('mm', 'MM');
  },
  dateTimeFormat() {
    return `${this.dateFormat()} ${this.timeFormat()}`;
  },
  timeInterval() {
    return GLOBAL_VAR.current_shop.settings.datepicker_time_interval;
  },
  savingFormat() {
    return 'YYYY-MM-DD HH:mm';
  },
  onErrorShow(message) {
    if (Array.isArray(message)) {
      message.forEach((msg) => {
        if (window.isPolarisLayout && window.store) { // defines that page use Polaris Layout
          btaa.polarisToast(msg, true, 'ADD_TOAST');
        } else {
          btaa.notify(msg, 'error');
        }
      });
    } else {
      btaa.notify(message, 'error');
    }
  },
  validURL(url) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(url);
  },
  validEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  },
  buildOptionsForSelect(array, titleField, blankOption=false){
    let options = blankOption ? [{label: blankOption, value: 0}] : []
    return options.concat(array.map((element) => {
        return {label: element[titleField], value: element.id}
      })
    )
  },
  buildDateRange(){
    return {
      'Today': [moment(), moment()],
      'Tomorrow': [moment().add(1, 'days'), moment().add(1, 'days')],
      'Next 7 Days': [moment(), moment().add(6, 'days')],
      'Next 30 Days': [moment(), moment().add(29, 'days')],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Next Month': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
    }
  },
  getValidationError(errors, key) {
    const error = errors.find(error => error.key == key && !error.fieldChanged)
    if (error) return error.value
  }
};

export default Utils;
